// extracted by mini-css-extract-plugin
export var root = "call-to-action-module--root--Vkp6d";
export var content = "call-to-action-module--content--giNx3";
export var buttons = "call-to-action-module--buttons--h8VOg";